export default theme => ({
  root: { marginTop: '1.75rem' },
  colorText: {
    color: 'rgba(0, 0, 0, 0.60)',
  },
  tableRow: {
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
    cursor: 'pointer',
    height: '4rem',
  },
  tableCellInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
  },
  colorTextCaption: {
    color: 'rgba(0, 0, 0, 0.38)',
  },
  progressWrapper: {
    height: '100%',
    paddingTop: '1rem',
    paddingBottom: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cellValorContratado: {
    paddingLeft: '5rem',
  },
  textValorContratado: {
    color: 'rgba(0, 0, 0, 0.60)',
    paddingLeft: '3.5rem',
  },
  textConsumoMedio: {
    color: 'rgba(0, 0, 0, 0.60)',
    paddingRight: '1.5rem',
  },
  tableCell: {
    padding: 0,
    margin: 0,
    maxWidth: '2rem',
  },
  boxOperacaoCadastro: {
    paddingRight: '2rem',
  },
  formatTextAlign: {
    alignItems: 'center',
  },
  tableEmpresas: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  tableCellPaddding: {
    padding: '0',
  },
});
